/* @flow */

import { extend, buildUrl } from '../utils/coreutils';
import openrtbBase from './openrtbbase';
// no per-source ID selection; include all via getRTBUserEids()

// Flow typedefs: using OpenRTB types from shared defs elsewhere (RTBBidResponse etc.)

/**
 * @module bidders/openx
 */
/**
 * @global
 * @description extends {@link hbConfig}
 * @property {string} [qpKey=openx] qp key
 * @property {string} id ID
 */
/**
 * @global
 * @typedef hbPosData
 * @property {string} info Info to log
 * @property {object} _QP - bid value(cpm) are populated here
 * @property {object} _CV - partner specific pos id
 */
/**
 * @description Implements functionality for openx header bidding
 * @exports openxbid
 * @augments openrtbBase
 * @requires module:utils
 * @requires module:bidmanager
 * @requires module:fetch
 * @requires module:adconfig
 */

const DEFAULT_END_POINT = 'https://rtb.openx.net/openrtbb/prebidjs';

class _openx extends openrtbBase {
  _DefConfig: openxBidConfig;

  _config: openxBidConfig;
  _syncDomain: string;

  constructor() {
    super('openx');
    this._DefConfig = extend(true, {}, this._DefConfig, {
      bidUrl: DEFAULT_END_POINT,
      qpKey: 'openx',
      delDomain: ''
    });
    this._config = extend(true, {}, this._DefConfig);
    this._mandatoryConfigs = ['bidUrl', 'delDomain'];
    this._syncDomain = this._config.delDomain;
    // OpenX doesn't support CORS OPTIONS request. So we need to set the content type to text/plain.
    this._reqContentType = 'text/plain';
  }

  _getRequestExt(): anyObject {
    return { delDomain: this._config.delDomain };
  }

  _getTagId(pos: string): string {
    // OpenX requires tagid populated from auid config
    const conf = this._config.posTokenMap[pos] || {};
    return conf.auid || '';
  }

  _getEndpoint(): string {
    return this._config.bidUrl || DEFAULT_END_POINT;
  }

  _updateSyncDomainFromResponse(response: RTBBidResponse) {
    // response.ext is bidder-specific; treat as unknown and narrow carefully
    let respDel = '';
    // $FlowFixMe[prop-missing]
    const rExt = response && typeof response === 'object' ? response.ext : null;
    if (
      rExt &&
      typeof rExt === 'object' &&
      typeof rExt.delDomain === 'string'
    ) {
      respDel = rExt.delDomain;
    }
    this._syncDomain =
      respDel && respDel.length ? respDel : this._config.delDomain;
  }

  _getUserSync(): Array<syncObj> {
    const name = this.getName();
    const type = 'iframe';
    const host = this._syncDomain || this._config.delDomain;
    const privacy = this._getPrivacyString();
    const qpObj = {};
    if (privacy.us_privacy) {
      // eslint-disable-next-line camelcase
      qpObj.us_privacy = privacy.us_privacy;
    }
    const url = buildUrl(`https://${host}/w/1.0/pd`, qpObj);
    return [{ name, type, url }];
  }
}

// add bidder to bidmanager
const openx: _openx = new _openx();
export default openx;
